import * as types from "../constants/ComponentConstants";
import { TochtTypeIds, TochtRedenVanStatus } from "../constants/DomainConstants";

import capitalize from "./stringFormatter";

const tochtTypeClassNames = {
    [TochtTypeIds.WANDELTOCHT]: "wandelen",
    [TochtTypeIds.RUITERTOCHT]: "ruitertocht",
    [TochtTypeIds.GEMOTORISEERDE_TOCHT]: "gemotoriseerd",
    [TochtTypeIds.MENNEN]: "mennen",
    [TochtTypeIds.LOOPTOCHT]: "lopen",
    [TochtTypeIds.MUSHING]: "mushing",
    [TochtTypeIds.FIETSTOCHT]: "fietsen"
};


function getTochtTypeText() {
    return {
        TochtTypePlural: "tochten",
        TochtTypePluralCapitalized: "Tochten",
        TochtTypeSingular: "tocht",
        TochtTypeSingularCapitalized: "Tocht",
        LusTypePlural: types.AFSTANDEN_TEKST,
        LusTypePluralCapitalized: capitalize(types.AFSTANDEN_TEKST),
        LusTypeSingular: types.AFSTAND_TEKST,
        LusTypeSingularCapitalized: capitalize(types.AFSTAND_TEKST)
    };
}

function wachtOpAanvullingDoorOrganisator(redenVanStatus, hasOpenGpxConflicten, hasOntbrekendeGpx) {
    return redenVanStatus === TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorSVL
        && (hasOpenGpxConflicten || hasOntbrekendeGpx);
}

function getStatusText(redenVanStatusNaam, redenVanStatus, hasOpenGpxConflicten, hasOntbrekendeGpx) {
    if(wachtOpAanvullingDoorOrganisator(redenVanStatus, hasOpenGpxConflicten, hasOntbrekendeGpx))
        return types.WACHT_OP_AANVULLING_DOOR_ORGANISATOR;

    return redenVanStatusNaam;
}

function getStatusTooltipText(redenVanStatus, hasOpenGpxConflicten, hasOntbrekendeGpx) {
    if(redenVanStatus === TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorFedKoepel)
        return types.STATUS_TOOLTIP_AFWACHTING_FEDKOEPEL;
    if(redenVanStatus === TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorSVL)
        return wachtOpAanvullingDoorOrganisator(redenVanStatus, hasOpenGpxConflicten, hasOntbrekendeGpx)
            ? types.STATUS_TOOLTIP_WACHT_OP_AANVULLING
            : types.STATUS_TOOLTIP_AFWACHTING_SVL_CONTROLE;
    if(redenVanStatus === TochtRedenVanStatus.DossierOnvolledig)
        return types.STATUS_TOOLTIP_DOSSIER_ONVOLLEDIG;
    if(redenVanStatus === TochtRedenVanStatus.DossierVolledig)
        return types.STATUS_TOOLTIP_DOSSIER_VOLLEDIG;
    if(redenVanStatus === TochtRedenVanStatus.DoorgestuurdTerGoedkeuring)
        return types.STATUS_TOOLTIP_DOORGESTUURD_TER_GOEDKEURING;

    return null;
}

function getTochtTypeClassName(tochtTypeId) {
    return tochtTypeClassNames[tochtTypeId] || "";
}

export {getTochtTypeText, getStatusText, getStatusTooltipText, getTochtTypeClassName};